import type {ReactNode} from 'react';
import {useTenantTheme} from '@common-web/providers/tenantThemeProvider';

const DEFAULT_HERO_IMAGE =
  'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=2000&q=80';

function HeroPanel({image}: {image: string}) {
  return (
    <div className='hidden lg:flex lg:w-1/2 relative bg-brand-navy'>
      <div
        className='absolute inset-0 bg-cover bg-center'
        style={{backgroundImage: `url('${image}')`}}
      >
        <div className='absolute inset-0 bg-brand-navy/90' />
      </div>
      <div className='relative z-10 flex flex-col justify-center p-12' />
    </div>
  );
}

export function AuthPageLayout({
  children,
  heroPosition = 'left',
}: {
  children: ReactNode;
  heroPosition?: 'left' | 'right';
}) {
  const {authLayout, heroImage} = useTenantTheme();
  const image = heroImage ?? DEFAULT_HERO_IMAGE;
  const isCentered = authLayout === 'centered';

  if (isCentered) {
    return (
      <div className='min-h-screen flex items-center justify-center p-8 bg-gray-50'>{children}</div>
    );
  }

  const formPanel = (
    <div className='w-full lg:w-1/2 flex items-center justify-center p-8 bg-gray-50'>
      {children}
    </div>
  );

  return (
    <div className='min-h-screen flex'>
      {heroPosition === 'left' && <HeroPanel image={image} />}
      {formPanel}
      {heroPosition === 'right' && <HeroPanel image={image} />}
    </div>
  );
}
